export const type = 'form.iconPicker';
